@import '^scss-config';

.root {
  display: flex;
  flex-direction: column;

  padding: 1rem;

  background: var(--background-color);
}

.widgetLayout {
  overflow-y: hidden;
}
